// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__LcH86","title":"AfterFrontImage_title__3Ps31"};